import { useLang } from '@/i18n';
import EfIcon from '@elem/ui/ef-icon';
import EcoImg from 'eco-design/base/eco-img';
import React from 'react';
import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useCountDown } from 'ahooks';
import { useProductStore } from '@elem/compPage/stream-series-plug-in-solar-battery/ProductProvider';
import { IPageStatus } from '@elem/compPage/stream-series-plug-in-solar-battery/config/IPageStatus';
import { useGlobal } from '@/utils/useGlobal';
import useStatusLang from '../../StatusC/useStatusCLang';
import { isStatusC } from '../../utils';

const OnlineStoreRightsA3: React.FC = () => {
    const { t } = useStatusLang('theProduct.OnlineStoreRightsA3');
    const { locale } = getLocal();
    const { getSystemTime } = useGlobal();
    const { timeLine, pageStatus } = useProductStore();
    const statusC = isStatusC();

    const [, formattedRes] = useCountDown({
        // leftTime: now - Number(startTime),
        leftTime: timeLine[IPageStatus.statusC].start - getSystemTime(),
    });
    const { days, hours, minutes, seconds } = formattedRes;

    const handleCompletion = (val: number) => (val < 10 ? `0${val}` : val);

    return (
        <section className={`${styles.OnlineStoreRightsA3} GtmModuleData-section`} data-section-id="OnlineStoreRightsA3" data-section-title={t('rights_title')}>
            {pageStatus !== IPageStatus.statusC && (
                <>
                    <div className="title">{t('rights_title')}</div>
                    <div className="countdown-box">
                        <div className="time-item">
                            <span className="num">{handleCompletion(days)}</span>
                            <span className="text">{t('day')}</span>
                        </div>
                        <span className="colon">:</span>
                        <div className="time-item">
                            <span className="num">{handleCompletion(hours)}</span>
                            <span className="text">{t('hours')}</span>
                        </div>
                        <span className="colon">:</span>
                        <div className="time-item">
                            <span className="num">{handleCompletion(minutes)}</span>
                            <span className="text">{t('minutes')}</span>
                        </div>
                        <span className="colon">:</span>
                        <div className="time-item">
                            <span className="num">{handleCompletion(seconds)}</span>
                            <span className="text">{t('seconds')}</span>
                        </div>
                    </div>
                </>
            )}

            <div className="rights-container">
                <div className="rights">
                    <div className="item1 item">
                        <div className="top-desc">
                            <p className="up-to">{t('rights_desc_a_1')}</p>
                            <p className="persent">{t('rights_desc_a_2')}</p>
                        </div>
                        <div className="bottom-desc">{t('rights_desc_a_3')}</div>
                        <EcoImg
                            pc="https://websiteoss.ecoflow.com/upload/image/1745410495343/pc-right-item1-eu.jpg"
                            pad="https://websiteoss.ecoflow.com/upload/image/1745410495343/pc-right-item1-eu.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1745410495157/m-right-item1-eu.jpg"
                            isOpenLazy
                        />
                    </div>
                    <div className="item2 item">
                        <div className="desc">
                            <p className="gradient-text">{t('rights_desc_b_1')}</p>
                            <p className="text">{t('rights_desc_b_2')}</p>
                        </div>
                    </div>
                    <div className="item3 item">
                        <div className="desc">
                            <p className="title1">{t('rights_desc_c_1')}</p>
                            {pageStatus !== IPageStatus.statusC && <p className="time-desc">{t('rights_desc_c_2')}</p>}
                        </div>
                        <EcoImg
                            className={statusC ? 'statusc_img' : ''}
                            pc="https://websiteoss.ecoflow.com/upload/image/1749095484039/3-PC.jpg"
                            pad="https://websiteoss.ecoflow.com/upload/image/1749095484039/3-PC.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1749095512822/3-m.jpg"
                            isOpenLazy
                        />
                    </div>
                    {/* <div className="item4 item">
                        <div className="desc">
                            <p className="title1">{t('rights_desc_d_1')}</p>
                            <p className="subtitle1">{t('rights_desc_d_2')}</p>
                            <p className="time-desc">{t('rights_desc_d_3')}</p>
                        </div>
                        <EcoImg
                            pc="https://websiteoss.ecoflow.com/upload/image/1745410495713/pc-right-item3-eu.jpg"
                            pad="https://websiteoss.ecoflow.com/upload/image/1745410495713/pc-right-item3-eu.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1745410496303/m-right-item4-eu.jpg"
                        />
                    </div> */}
                    <div className="item5 item">
                        <div className="desc">
                            <div className="top-desc">
                                <p className="title1">{t('rights_desc_e_1')}</p>
                                {pageStatus !== IPageStatus.statusC && <p className="time-desc">{t('rights_desc_e_2')}</p>}
                            </div>
                            <div className="bottom-desc">
                                <p className="underline-price">{t('rights_desc_e_3')}</p>
                                <p className="price">{t('rights_desc_e_4')}</p>
                            </div>
                        </div>
                        <EcoImg
                            pc="https://websiteoss.ecoflow.com/upload/image/1747116438935/pc-right-5-bg.png"
                            pad="https://websiteoss.ecoflow.com/upload/image/1747116438935/pc-right-5-bg.png"
                            h5="https://websiteoss.ecoflow.com/upload/image/1747116446455/m-right-5-bg.png"
                            isOpenLazy
                        />
                    </div>
                    <div className="item6 item">
                        <div className="desc">
                            <p className="price">{t('rights_desc_f_1')}</p>
                            <p className="title1">{t('rights_desc_f_2')}</p>
                        </div>
                        <EcoImg
                            pc="https://websiteoss.ecoflow.com/upload/image/1745410496829/pc-right-item5-eu.jpg"
                            pad="https://websiteoss.ecoflow.com/upload/image/1745410496829/pc-right-item5-eu.jpg"
                            h5="https://websiteoss.ecoflow.com/upload/image/1747117072771/m-right-6-bg.png"
                            isOpenLazy
                        />
                    </div>
                </div>
                {/* {locale !== 'it' && (
                    <div className="win-ultra">
                        <div className="left-content">
                            <p className="title1">{t('rights_win_title')}</p>
                            <p className="desc1">{t('rights_win_desc')}</p>
                        </div>
                        <div className="winner-prod">
                            <EcoImg
                                pc={winnerUltraMap[locale].pc || winnerUltraMap['eu'].pc}
                                pad={winnerUltraMap[locale].pad || winnerUltraMap['eu'].pad}
                                h5={winnerUltraMap[locale].h5 || winnerUltraMap['eu'].h5}
                            ></EcoImg>
                        </div>
                    </div>
                )}

                <div className="time-line time-line-only-2">
                    <div className="line">
                        <div className="lihe-bg"></div>
                        <div className="item-container">
                            <div className="line-item item1">
                                <EfIcon className="line-icon" pc="https://websiteoss.ecoflow.com/upload/image/1745829705574/line-icon.png" />
                                <div className="line-box">
                                    <p className="line-title">{t('rights_time_a_1')}</p>
                                    <ul className="">
                                        <li className="first">{t('rights_time_a_2')}</li>
                                        <li>{t('rights_time_a_3')}</li>
                                        <li>{t('rights_time_a_4')}</li>
                                        <li>{t('rights_time_a_5')}</li>
                                    </ul>
                                </div>
                            </div>
                            <div className="line-item item3">
                                <EfIcon className="line-icon" pc="https://websiteoss.ecoflow.com/upload/image/1745829705574/line-icon.png" />
                                <div className="line-box">
                                    <p className="line-title">{t('rights_time_b_1')}</p>
                                    <ul className="">
                                        <li>{t('rights_time_b_2')}</li>
                                        <li>{t('rights_time_b_3')}</li>
                                        {t('rights_time_b_4') && <li>{t('rights_time_b_4')}</li>}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>
        </section>
    );
};

export default OnlineStoreRightsA3;
